module.exports = __webpack_public_path__ + "static/Thumb_NC1_Desert_comp-815e1eab5e65caaa4b9f986e6083cf8d.png";